// Shared pill/button color classes - avoids Tailwind purge issues.
// Used by PillSelector when callers opt into per-option coloring via colorMap.
// Each entry includes dark: variants so colored pills remain legible in dark mode.
export const COLOR_CLASSES = {
  emerald: {
    sel: "bg-emerald-500 text-white border-emerald-500 dark:bg-emerald-600 dark:border-emerald-600",
    unsel: "bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-900 dark:hover:bg-emerald-900",
  },
  blue: {
    sel: "bg-blue-500 text-white border-blue-500 dark:bg-blue-600 dark:border-blue-600",
    unsel: "bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900 dark:hover:bg-blue-900",
  },
  amber: {
    sel: "bg-amber-500 text-white border-amber-500 dark:bg-amber-600 dark:border-amber-600",
    unsel: "bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900 dark:hover:bg-amber-900",
  },
  red: {
    sel: "bg-red-500 text-white border-red-500 dark:bg-red-600 dark:border-red-600",
    unsel: "bg-red-50 text-red-700 border-red-200 hover:bg-red-100 dark:bg-red-950 dark:text-red-300 dark:border-red-900 dark:hover:bg-red-900",
  },
  slate: {
    sel: "bg-slate-600 text-white border-slate-600 dark:bg-slate-500 dark:border-slate-500",
    unsel: "bg-slate-50 text-slate-600 border-slate-200 hover:bg-slate-100 dark:bg-slate-900 dark:text-slate-300 dark:border-slate-800 dark:hover:bg-slate-800",
  },
};

// Learning Skills / Work Habits color map: grade letter → COLOR_CLASSES key
export const LSWH_COLOR_MAP = { E: "emerald", G: "blue", S: "amber", N: "red" };
